import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash-es';
import { Modal, Button } from 'react-bootstrap';
import prepareTheme from 'containers/ThemeProvider/prepareTheme.js';
import { isSmallScreen } from 'utils/checkMedia.js';
import Form4 from 'components/interaction/Form4/index.jsx';
import useSchoolSettings from '../../hooks/useSchoolSettings.js';
import messages from './messages.js';
import schema from './form.js';
import Preview from './Preview.jsx';

function Theme() {
  const { settings, changeDetail } = useSchoolSettings();
  const { theme, name } = settings;
  const [show, setShow] = useState(false);
  const defaultValues = { ...theme, color: get(theme, 'themeColor.hex') };
  const [values, setValues] = useState(defaultValues);

  function handleChange(newValues, key) {
    let value = newValues[key];
    if (value?.preview) {
      value = value.preview;
    }
    setValues((o) => ({ ...o, [key]: value }));
  }

  function handleClose() {
    setShow(false);
    setValues(defaultValues);
  }

  function handleSubmit(data) {
    changeDetail('theme', prepareTheme(data));
    handleClose();
  }

  return (
    <div>
      <h3><FormattedMessage {...messages.header} /></h3>
      <p className="form-text mb-0"><FormattedMessage {...messages.intro} /></p>
      <div>
        <Button variant="link" className="ps-0 fw-semibold" onClick={() => setShow(true)}>
          <FormattedMessage {...messages.adaptTheme} />
        </Button>
        <Modal show={show} dialogClassName="modal-lg" onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>
              <FormattedMessage {...messages.adaptTheme} />
            </Modal.Title>
          </Modal.Header>
          <Form4
            onSubmit={handleSubmit}
            onChange={handleChange}
            schema={schema}
            defaultValues={defaultValues}
            onCancel={handleClose}
            horizontal={!isSmallScreen()}
          >
            {({ body, action }) => (
              <>
                <Modal.Body>
                  <div className="d-sm-flex">
                    <div className="w-50">
                      {body}
                    </div>
                    <div className="w-50 text-center ms-sm-5">
                      <h4>Preview</h4>
                      <Preview {...values} name={name} className="m-auto" />
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  {action}
                </Modal.Footer>
              </>
            )}
          </Form4>
        </Modal>
      </div>
    </div>
  );
}

// Theme.propTypes = {
// };

export default Theme;
